import { useRecoilState } from 'recoil'
import projectTypesInspectionOverviewAtom from '../projectTypesInspectionOverview.atom'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useEffect } from 'react'
import inspectionApi from '../inspection.api'

const useProjectTypesInspectionOverviewState = () => {
  const [state, setState] = useRecoilState(projectTypesInspectionOverviewAtom)

  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (!state.items.length) {
      wait(inspectionApi.getProjectTypesInspectionOverview(), (resp) => {
        if (resp.status === 'success') {
          setState(() => ({
            items: resp.body,
          }))
        }
      })
    }
  }, [])

  return { items: state.items, loading }
}

export default useProjectTypesInspectionOverviewState
